import { Field, FieldInputProps, FieldProps, useFormikContext } from "formik";
import React, { ComponentProps } from "react";

import { ReactInput } from "@storeblocks/input/lib";
import { default as StoreblocksSwitch } from "@storeblocks/switch";

interface Props
  extends Omit<
    ComponentProps<typeof StoreblocksSwitch>,
    "checked" | "onChange"
  > {
  id: string;
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    field?: FieldInputProps<any>,
  ) => void;
  inputProps?: ReactInput;
}

/**
 * Renders switch based on @storeblocks/switch.
 */
export const Switch = ({
  id,
  name,
  label,
  disabled,
  onChange,
  inputProps,
}: Props): React.ReactElement => {
  const formikContext = useFormikContext<Record<string, unknown>>();

  return (
    <Field name={name} type="checkbox">
      {({ field }: FieldProps) => (
        <StoreblocksSwitch
          {...field}
          id={id}
          label={label}
          checked={Boolean(field.checked)}
          disabled={disabled}
          onChange={(e) => {
            formikContext.setFieldValue(id, e.target.checked);
            formikContext.validateForm({
              ...formikContext.values,
              [id]: e.target.checked,
            });
            onChange && onChange(e, field);
          }}
          inputProps={inputProps}
          style={{ marginBottom: "24px" }}
        />
      )}
    </Field>
  );
};
